import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import cloneDeep from 'lodash.clonedeep';
import { ToastrService } from 'ngx-toastr';
import { BackupDeviceType } from 'src/app/model/backup-device-type';
import { BackupStorageDeviceDTO } from 'src/app/model/backup-storage-device-dto';
import { BackupService } from 'src/app/services/backup.service';

@Component({
    selector: 'app-edit-backup-device',
    standalone: true,
    imports: [CommonModule, FormsModule, MatIconModule, MatCheckboxModule, ReactiveFormsModule],
    templateUrl: './edit-backup-device.component.html',
    styleUrl: './edit-backup-device.component.scss'
})
export class EditBackupDeviceComponent {
    public editMode: boolean = false
    public working: boolean = false
    form!: FormGroup;
    public deviceCIFS: number = BackupDeviceType.CIFS;
    public deviceNFS: number = BackupDeviceType.NFS;

    constructor(
        public backupService: BackupService,
        public dialogRef: MatDialogRef<Component>,
        @Inject(MAT_DIALOG_DATA) public data: BackupStorageDeviceDTO,
        private readonly toastr: ToastrService
    ) {
        this.editMode = data?.id != null

        const deviceCopy = cloneDeep(data)

        this.form = new FormGroup({
            address: new FormControl(deviceCopy?.address ?? '', [Validators.required, deviceAddressValidator()]),
            name: new FormControl(deviceCopy?.name ?? '', Validators.required),
            user: new FormControl(deviceCopy?.user ?? '', Validators.required),
            password: new FormControl(deviceCopy?.password ?? '', Validators.required),
            type: new FormControl(deviceCopy?.type ?? null, Validators.required),
            rootFolder: new FormControl(deviceCopy?.rootFolder ?? '')
        })
    }

    invalidIpAddress(): boolean {
        return this.form.controls['address'].errors != null
    }

    public save() {
        this.working = true

        const device: BackupStorageDeviceDTO = {
            id: this.data?.id,
            name: this.form.value.name,
            address: this.form.value.address,
            user: this.form.value.user,
            password: this.form.value.password,
            type: +this.form.value.type,
            rootFolder: this.form.value.rootFolder
        }

        let action = this.editMode ?
            this.backupService.updateBackupDevice(device)
            : this.backupService.createBackupDevice(device)

        action
            .then(response => {
                this.toastr.success('Device saved!')
                this.dialogRef.close(true)
                this.working = false
            })
            .catch(error => {
                this.toastr.error('Error saving this device.')
            })
    }

    public cancel(): void {
        this.dialogRef.close()
    }
}

export function deviceAddressValidator(): ValidatorFn {
    return (control: AbstractControl) => {
        const regex = /^(?:\d{1,3}\.){3}\d{1,3}$/;

        if (regex.test(control.value)) {
            return null;
        }

        return { ipError: true };
    };
}
